import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import Container from "../../bootstrap/Container";
import Layout from "../../bootstrap/Layout/";
import {
  BackButton,
  PersonDetail,
  TestimonialDescription,
  TestimonialImage,
  TestimonialTitle,
  TestimonialWrapper,
} from "./SingleTestimonial.style";

const SingleTestimonials = () => {
  const [singleTest, setSingleTest] = useState([]);
  const { id } = useParams();
  const [userProfileInfo, setUserProfileInfo] = useState(null);
  const { webSettingData } = useSelector((state) => state.busLists);
  const history = useHistory();

  useEffect(() => {
    setUserProfileInfo(JSON.parse(localStorage.getItem("userProfileInfo")));
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_DOMAIN}/comments/${id}`)
      .then((res) => res.json())
      .then((data) => setSingleTest(data.data));
  }, [id]);

  return (
    <Layout title={`Avis — ${singleTest?.person_name || ""}`} userProfileInfo={userProfileInfo}>
      <Container>
        <TestimonialWrapper
          headercolor={webSettingData?.headercolor}
          btncolor={webSettingData?.buttoncolor}
        >
          <TestimonialImage
            src={singleTest?.image}
            alt={singleTest?.person_name || "Photo"}
            btncolor={webSettingData?.buttoncolor}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Ccircle cx='100' cy='100' r='100' fill='%23e8e8e8'/%3E%3Ccircle cx='100' cy='80' r='35' fill='%23bdbdbd'/%3E%3Cellipse cx='100' cy='160' rx='55' ry='45' fill='%23bdbdbd'/%3E%3C/svg%3E";
            }}
          />
          <TestimonialTitle>{singleTest?.person_name}</TestimonialTitle>
          <PersonDetail btncolor={webSettingData?.buttoncolor}>
            {singleTest?.person_detail}
          </PersonDetail>
          <TestimonialDescription
            headercolor={webSettingData?.headercolor}
            btncolor={webSettingData?.buttoncolor}
            dangerouslySetInnerHTML={{ __html: singleTest?.description }}
          />
          <BackButton
            onClick={() => history.goBack()}
            btnbgcolor={webSettingData?.buttoncolor}
            btnbghvcolor={webSettingData?.buttoncolorhover}
            btntextcolor={webSettingData?.buttontextcolor}
          >
            Retour
          </BackButton>
        </TestimonialWrapper>
      </Container>
    </Layout>
  );
};

export default SingleTestimonials;
